// extracted by mini-css-extract-plugin
export var content = "page-module--content--Wy0I2";
export var navigation = "page-module--navigation--c-Hv2";